'use strict';

intellidealerAppCoreModule.factory('tablesResource', function ($resource, appConfigurationService) {

  var resource = {}; 

  return resource;
});
